/**
 * Format number to Indonesian locale (comma as decimal separator, 1 decimal)
 * @param {number} value - Number to format
 * @param {number} decimals - Number of decimal places (default: 1)
 * @returns {string} Formatted number string
 */
export const formatNumber = (value, decimals = 1) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0';
  }
  // Convert to number and fix decimal places
  const num = Number(value).toFixed(decimals);
  // Replace period with comma for Indonesian format
  return num.replace('.', ',');
};

/**
 * Format kcal value as whole number (no decimal)
 * @param {number} value - Kcal value
 * @returns {string} Rounded number as string
 */
export const formatKcal = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0';
  }
  return String(Math.round(Number(value)));
};

/**
 * Format percentage to Indonesian locale (comma as decimal separator, 1 decimal)
 * @param {number} value - Percentage value
 * @param {number} decimals - Number of decimal places (default: 1)
 * @returns {string} Formatted percentage string with %
 */
export const formatPercentage = (value, decimals = 1) => {
  return formatNumber(value, decimals) + '%';
};
